export const defaultDAppToast = {
    info: (message) => console.info(message),
    error: (message) => console.error(message),
    success: (message) => console.log(message),
};
/** Adapter for react-hot-toast (admin-panel). */
export function createReactHotToastAdapter(toast) {
    return {
        info: (message) => toast(message),
        error: (message) => toast.error(message),
        success: (message) => toast.success(message),
    };
}
/** Adapter for react-toastify. */
export function createReactToastifyAdapter(toast) {
    return {
        info: (message, options) => toast.info(message, options),
        error: (message) => toast.error(message),
        success: (message) => toast.success(message),
    };
}
